import { Box, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router';

export const BreadCrumbs = ({ paths = [], seprator = '>' }) => {
  const { pathname } = useLocation();
  const isActive = (route) => pathname === route;
  return (
    <Stack
      display="flex"
      flexDirection="row"
      alignItems="center"
      justiyContent="flex-start"
      sx={{ bgcolor: '#fafafa', borderRadius: 1, px: 3, py: 1 }}
    >
      {paths?.map((path, index) => (
        <>
          <Typography
            sx={{
              cursor: 'pointer',
              color: 'GrayText',
              ...(isActive(path.route) && {
                color: 'black',
                fontWeigth: 700,
              }),
              '&:active': {
                color: 'black',
                fontWeigth: 700,
              },
              '&:hover': {
                color: 'black',
                fontWeigth: 700,
              },
            }}
          >
            {path.title}
          </Typography>
          {index + 1 !== paths.length && (
            <Box component="span" sx={{ mx: 1 }}>
              {seprator}
            </Box>
          )}
        </>
      ))}
    </Stack>
  );
};
